export default __webpack_public_path__ + "static/media/1920 utensils top.f526a30c.png";